import type { User } from "./types";

export interface MentionUsersQuery {
  keyword?: string;
  page: number;
  limit: number;
}

export interface MentionUsersPage {
  users: User[];
  total: number;
  page: number;
  pages: number;
  hasMore: boolean;
}

const asPositiveNumber = (value: unknown, fallback: number) =>
  typeof value === "number" && Number.isFinite(value) && value >= 0
    ? value
    : fallback;

export const normalizeMentionUsersPage = (
  data: unknown,
  query: Pick<MentionUsersQuery, "page" | "limit">,
): MentionUsersPage => {
  const record =
    typeof data === "object" && data !== null
      ? (data as Record<string, unknown>)
      : null;
  const isPaginated = Boolean(record && Array.isArray(record.results));
  const items = Array.isArray(data)
    ? data
    : isPaginated
      ? (record?.results as unknown[])
      : [];
  const users = items.flatMap((item) => {
    if (typeof item !== "object" || item === null) return [];
    const itemRecord = item as Record<string, unknown>;
    const candidate = itemRecord.user ?? item;
    return typeof candidate === "object" && candidate !== null
      ? [candidate as User]
      : [];
  });
  const total = asPositiveNumber(record?.total, users.length);
  const page = asPositiveNumber(record?.page, query.page);
  const pages = asPositiveNumber(record?.pages, Math.ceil(total / query.limit));
  const pageUsers = isPaginated
    ? users
    : users.slice((page - 1) * query.limit, page * query.limit);

  return { users: pageUsers, total, page, pages, hasMore: page < pages };
};
